'use client';

import { Loader2 } from 'lucide-react';
import { useFormStatus } from 'react-dom';

import { Button } from '@/components/ui/button';

/**
 * Sign-in submit button with a pending state.
 *
 * The login form posts to a server action; without feedback the button looks
 * inert after a click. `useFormStatus` (a child of the <form>) flips to
 * `pending` while the action runs, so we disable the button and show a spinner
 * — the user gets immediate acknowledgement instead of a dead click.
 */
export function SignInSubmitButton() {
  const { pending } = useFormStatus();
  return (
    <Button
      type="submit"
      className="h-12 w-full rounded-[10px] text-[14.5px]"
      disabled={pending}
      aria-busy={pending}
    >
      {pending ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
          Signing in…
        </>
      ) : (
        'Sign in'
      )}
    </Button>
  );
}
